import { GET_EPISODE_PENDING, GET_EPISODE_SUCCESS, GET_EPISODE_FAILED } from "consts/actions"

import formatterHelper from "helpers/formatter"
import stateHelper from "helpers/state"
import localStorageHelper from "helpers/localStorage"

import consts from "consts"

export function getEpisode(channelId, episodeId) {
  const accessToken = localStorageHelper.getSession()?.auth?.access_token
  const baseUrl = formatterHelper.basic(consts.endpoints.episode, { channelId, episodeId })
  const getEpisodeUrl = accessToken ? `${baseUrl}?access_token=${accessToken}` : baseUrl

  return {
    accessTokenRequired: false,
    request: {
      url: getEpisodeUrl,
      method: "GET",
    },
    onStart: (payload, meta, dispatch) => {
      dispatch({
        type: GET_EPISODE_PENDING,
      })
    },
    onSuccess: (payload, meta, dispatch) => {
      dispatch({
        type: GET_EPISODE_SUCCESS,
        payload,
      })
    },
    onError: (payload, meta, dispatch) => {
      dispatch({
        type: GET_EPISODE_FAILED,
        payload: stateHelper.errorPayload(payload.user_message, meta.httpCode),
      })
    },
  }
}
